export const recordDuration = (secs) => {
  let hr = Math.floor(secs / 3600);
  let min = Math.floor((secs - (hr * 3600)) / 60);
  let sec = Math.floor(secs - (hr * 3600) - (min * 60));

  if (min < 10) {
      min = "0" + min;
  }

  if (sec < 10) {
      sec = "0" + sec;
  }

  return min + ':' + sec;
}

export const trimTime = (secs) => {
  let hr = Math.floor(secs / 3600);
  let min = Math.floor((secs - (hr * 3600)) / 60);
  let sec = secs - (hr * 3600) - (min * 60);

  if (hr < 10) {
      hr = "0" + hr;
  }
  
  if (min < 10) {
      min = "0" + min;
  }

  if (sec < 10) {
      sec = "0" + sec;
  }

  return hr + ':' + min + ':' + sec;
}